import React from "react";
import "./EmptyState.scss";

type Props = {
  message?: string;
};

const EmptyState: React.FC<Props> = ({
  message = "This list is currently empty.",
}) => {
  return (
    <div className="empty-state">
      <div className="empty-state__icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 4h5l2 2h9v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4z" />
          <path d="M3 13h4l2 3h6l2-3h4" />
        </svg>
      </div>

      <p className="empty-state__text">{message}</p>
    </div>
  );
};

export default EmptyState;
